package com.example.hukakmp.chat

import kotlinx.browser.window

private fun key(uid: String) = "huka_chat_history_v1_$uid"

actual object ChatPersistence {
    actual fun load(uid: String): String? = window.localStorage.getItem(key(uid))

    actual fun save(uid: String, value: String) {
        window.localStorage.setItem(key(uid), value)
    }

    actual fun clear(uid: String) {
        window.localStorage.removeItem(key(uid))
    }
}
